import { useState, useEffect } from 'react'
import classnames from 'classnames'

import ScaleImage from 'src/assets/img/Scale.png'
import SecurityImage from 'src/assets/img/Security.png'
import SdkImage from 'src/assets/img/Sdk.png'
import InnovationImage from 'src/assets/img/Innovation.png'
import SupportImage from 'src/assets/img/Support.png'

const Carousel = () => {
  const [current, setCurrent] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => {
      if (current === 4) {
        setCurrent(0)
      } else {
        setCurrent(current + 1)
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [current])

  const items = [
    {
      img: ScaleImage,
      title: 'Simplified workflow',
      description:
        'A clean, minimalist system that makes sense. No unnecessary complexities so that you can focus on what truly matters - completing tasks and achieving goals.',
    },
    {
      img: SecurityImage,
      title: 'Security',
      description:
        'Harness blockchain-level security on a trustworthy platform. Web3 products are inherently secure, allowing your team to focus on security best practices to ensure users’ data is safe.',
    },
    {
      img: SdkImage,
      title: 'Included APIs and SDKs',
      description:
        'A comprehensive suite of APIs and SDKs simplify the creation of tailored applications, integrations, and tools. Pre-built components and thorough documentation kickstart your unique requirements.',
    },
    {
      img: InnovationImage,
      title: 'Open to Innovators, No Charges',
      description:
        'A range of essential features at no cost, allowing you to explore its powerful capabilities and create essential tools without any financial commitment.',
    },
    {
      img: SupportImage,
      title: 'Community support',
      description:
        'Fostering a collaborative environment where you can learn, share, and grow while creating decentralized applications, NFT marketplaces, and tokenization projects. Expert advice, documentation, and blazing-fast tech support.',
    },
  ]
  return (
    <div className="relative">
      <div>
        <img src={items[current].img} alt="Scale" className="mb-10" />
        <h2 className="mb-3 text-white">{items[current].title}</h2>
        <p className="h-20 font-normal text-white">{items[current].description}</p>
      </div>
      <div className="absolute -bottom-12 left-0 grid w-full grid-flow-col gap-4">
        {Object.keys(items).map((key, index) => (
          <span
            className={classnames('h-1 rounded-full bg-white bg-opacity-20', {
              '!bg-main-blue bg-opacity-100': index === current,
            })}
            key={key}></span>
        ))}
      </div>
    </div>
  )
}

export default Carousel
